import { AsyncState, loadingAsyncState } from "widgets-for-react";
import { FormAppState } from "../../../form/renderers";
import { form_state_to_key_vaule_pair } from "./beslismatrixWizardState";
import i18next from 'i18next';

export let submit_form_state = (state: FormAppState): AsyncState<string> => {
  return loadingAsyncState(async () => {
    let headers = new Headers()
    headers.append('content-type', 'application/json')

    let raw_data = form_state_to_key_vaule_pair(state.formState)
    let employeeCount = raw_data.find(f => f.field_name == "Tab1.Q3").field_value.toLowerCase() // Employee count field
    let sector = raw_data.find(f => f.is_sector_field).field_value.toLowerCase()
    var res = fetch('/api/v1/beslismatrix', {
      method: "post",
      body: JSON.stringify({
        Content: JSON.stringify(raw_data),
        FromEmail: raw_data.find(f => f.is_email).field_value,
        ForSectorEmail: getEmail(sector),
        OfficeMail: 'binnendienst@bsl.nl',
        MarketingMail: 'elearning@bsl.nl',
        AdviceUrl: getAdviceUrl(sector, employeeCount)
      }),
      headers: headers
    })
    if (!(await res).ok) {
      console.error("something went wrong")
      return {
        kind: "failed",
        status: 400
      }
    }
    return {
      kind: "result",
      status: 200,
      value: "ok"
    }
  })
}

export let getJobFunctionData = (): string[] => {
  return [
    "Apothekersassistenten",
    "Bedrijfsartsen",
    "Doktersassistenten",
    "Fysiotherapeuten",
    "Gespecialiseerd verpleegkundigen",
    "Helpenden",
    "Huisartsen",
    "Medisch specialisten (io)",
    "Praktijkondersteuners",
    "Praktijkverpleegkundigen",
    "Psychologen",
    "Tandartsassistenten",
    "Tandartsen",
    "Verpleegkundig specialisten",
    "Verpleegkundigen",
    "Verzekeringsartsen",
    "Verzorgenden",
    "Wijkverpleegkundigen",
    "Anders ",
    i18next.t("Tab2.Q1_All_Job_Functions")
  ]
}

export let getThemeData = (): string[] => {
  return [
    "Basic Life Support",
    "Basiszorg",
    "Bewegingsondersteuning",
    "Chroniciteit",
    "Dementie",
    "Gehandicaptenzorg",
    "Gynaecologie & obstetrie",
    "Hygiene en infectiepreventie",
    "Leefstijlgeneeskunde",
    "Medicijnen",
    "Medisch rekenen",
    "Oncologie",
    "Palliatieve zorg",
    "Persoonlijke ontwikkeling",
    "Risico en voorbehouden handelingen",
    "Samen beslissen",
    "Tandheelkunde",
    "Vitale functies",
    "Wet zorg en dwang",
    "Wondzorg",
    "Ziektebeelden",
    "Anders ",
    i18next.t("Tab2.Q2_All_Themes")
  ]
}

export let getSupplierData = (): string[] => {
  return [
    "Bohn Stafleu van Loghum",
    "Doczero",
    "E-learning made easy",
    "Expert College",
    "Noordhoff",
    "Profportaal Zorg",
    "The Competence Group",
    "Maken we nog geen gebruik van",
    "Ik weet het niet",
    "Anders "
  ]
}
export let getSupplierLMSData = (): string[] => {
  return [
    "aNewSpring",
    "Doczero Academy",
    "E-Nursing",
    "Edubus",
    "ExpertCollege",
    "Flowsparks",
    "GoodHabitz",
    "LearnLinq",
    "PlusPort LMS Academy",
    "PulseWeb",
    "Pynther",
    "Straight Training",
    "Maken we nog geen gebruik van",
    "Ik weet het niet",
    "Anders "
  ]
}

export let getEmployeeCountData = (): string[] => {
  return [
    "1 - 50",
    "50 - 100",
    "100 - 250",
    "250 - 500",
    "500+",
  ]
}

export let getSectorData = (): string[] => {
  return [
    "Eerstelijns zorg",
    "Beroepsverenigingen",
    "Fysiotherapie",
    "GGZ",
    "Hoger beroepsonderwijs",
    "Middelbaar beroepsonderwijs",
    "Tandheelkunde",
    "Thuiszorgorganisaties",
    "Verpleeg- en verzorgingshuizen",
    "Wetenschappelijk onderwijs",
    "Ziekenhuizen",
    "Zorggroepen",
    "Anders ",
  ]
}

let getEmail = (sector: string) => {
  switch (sector) {
    case 'fysiotherapie':
    case 'eerstelijns zorg':
    case 'tandheelkunde':
    case 'zorggroepen':
      return 'hamed.altaf@bsl.nl';

    case 'ggz':
    case 'thuiszorgorganisaties':
    case 'verpleeg- en verzorgingshuizen':
    case 'ziekenhuizen':
      return 'diederik.blok@bsl.nl';

    case 'hoger beroepsonderwijs':
    case 'wetenschappelijk onderwijs':
      return 'bas.dewit@bsl.nl';

    case 'middelbaar beroepsonderwijs':
      return 'stijn.bouwmeester@bsl.nl';

    case 'beroepsverenigingen':
      return 'karin.linden@bsl.nl';

    default: // Anders
      return 'hamed.altaf@bsl.nl';
  }
}

export let getAdviceUrl = (sector: string, employeeCount: string) => {
  let employeeCountData = getEmployeeCountData()
  switch (sector) {
    case 'fysiotherapie':
    case 'eerstelijns zorg':
    case 'zorggroepen':
      return "https://www.bsl.nl/oplossingen/e-learning/zorggroepen/"


    case 'tandheelkunde':
      return 'https://www.tandartspraktijk.nl/nascholing/';

    case 'ggz':
      return 'https://www.bsl.nl/oplossingen/e-learning/ggz';

    case 'thuiszorgorganisaties':
    case 'verpleeg- en verzorgingshuizen':
    case 'ziekenhuizen':
      if (employeeCount == employeeCountData[0]) {
        return "https://www.bsl.nl/oplossingen/e-learning/pakket"
      } else {
        return 'https://www.bsl.nl/oplossingen/e-learning/vvt/';
      }

    case 'hoger beroepsonderwijs':
    case 'middelbaar beroepsonderwijs':
    case 'wetenschappelijk onderwijs':
      return 'https://www.bsl.nl/oplossingen/e-learning/educatief/';

    case 'ggz':
      return 'https://www.bsl.nl/oplossingen/e-learning/ggz';

    case 'beroepsverenigingen':
      return 'https://www.bsl.nl/oplossingen/e-learning/samen-jouw-e-learning-maken/';

    default: // Anders
      return 'https://www.bsl.nl/oplossingen/e-learning/';
  }
}